import React from 'react'
import { Button } from 'components/UIElements'
import PropTypes from 'prop-types'
import 'styles/d3/modal.scss'
import { connect } from 'react-redux'
import { modalActions } from 'store/modal'
import { humiS, sadHumi } from '../assets/assets'

const Modal = props => {
  const {
    cancelButton,
    children,
    className,
    closeModal,
    closeOnBackgroundClick,
    closeX,
    confirmButton,
    confirmButtonExtraText,
    content,
    happyHumi,
    heading,
    height,
    humi,
    noButtons,
    onCancel,
    onConfirm,
    open,
    width,
  } = props
  const style = {
    height: height || '',
    width: width || '',
  }
  const containerClassName = `d3-modal modal-${open ? 'open' : 'closed'}${
    className ? ` ${className}` : ''
  }`
  return (
    <div
      onClick={closeOnBackgroundClick ? onCancel || closeModal : null}
      className={containerClassName}
    >
      <div style={style} onClick={e => e.stopPropagation()} className='content'>
        {(!humi || closeX) && (
          <i
            className='fa fa-times clickable'
            onClick={onCancel || closeModal}
          />
        )}
        {humi && (
          <div className='sad-humi-container'>
            <img className='sad-humi' src={happyHumi ? humiS : sadHumi} alt='sad-humi' />
          </div>
        )}
        <div className='top'>
          {heading && <h4>{heading}</h4>}
          {children || content}
        </div>
        {!noButtons && (
          <div className='bottom flexed'>
            <Button
              grey
              id='modal-cancel'
              content={cancelButton || 'Cancel'}
              onClick={() => {
                if (onCancel) onCancel()
                closeModal()
              }}
            />
            <div className='stacked-text'>
              <Button
                id='modal-confirm'
                className='confirm'
                content={confirmButton || 'Confirm'}
                onClick={() => {
                  if (onConfirm) onConfirm()
                  closeModal()
                }}
              />
              {confirmButtonExtraText && <p>{confirmButtonExtraText}</p>}
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

Modal.propTypes = {
  cancelButton: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  closeModal: PropTypes.func,
  closeOnBackgroundClick: PropTypes.bool,
  closeX: PropTypes.bool,
  confirmButton: PropTypes.string,
  confirmButtonExtraText: PropTypes.string,
  content: PropTypes.node,
  happyHumi: PropTypes.bool,
  heading: PropTypes.string,
  height: PropTypes.number,
  humi: PropTypes.bool,
  noButtons: PropTypes.bool,
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func,
  open: PropTypes.bool,
  width: PropTypes.number,
}

export default connect(
  null,
  modalActions,
)(Modal)



// WEBPACK FOOTER //
// ./src/components/Modal.js